import { Grid, List, Typography } from '@mui/material'

import { ConnectionListItem } from './connections-list-item.component'
import { PlusIcon } from 'src/assets/icons'
import { IStepAccountsConnectionRespDto, IStepFormSelectedAccount } from 'src/types'

import useStyles from 'src/components/associations/styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  items: IStepAccountsConnectionRespDto[]
  handleSelectItem: (value: string) => void
  handleToggleSwitchItem: () => void
  selectedItem: IStepFormSelectedAccount | null
  isDisabled?: boolean
}

const AccountConnectionsList = ({
  isDisabled,
  selectedItem,
  items,
  handleSelectItem,
  handleToggleSwitchItem,
}: IProps) => {
  const classes = useStyles({})

  return (
    <List className={classes.selectionList} disablePadding>
      {items.map((item) => (
        <ConnectionListItem
          isDisabled={isDisabled}
          landingShow={
            selectedItem ? selectedItem.landing_page_show : item.connection?.landing_page_show
          }
          icon={item.image_small || item.image}
          text={item.account_holder}
          key={item.id}
          handleSelectItem={handleSelectItem}
          handleToggleItem={handleToggleSwitchItem}
          id={item.id}
          approvedConnection={item.connection?.account_approved ?? null}
          aiGenerated={item.ai_generated}
        />
      ))}
      {items.length === 0 && !isDisabled && (
        <label className={classes.selectionLabel} htmlFor={`accounts-connection`}>
          <Grid className={classes.selectionWrapper}>
            <Grid className={classes.selectionItem}>
              <Grid className={classes.imageIconWrapper}>
                <PlusIcon className={classes.imageIcon} />
              </Grid>
              <Typography className={`${classes.selectionText} ${classes.selectionTextLight}`}>
                <HelperWrapper t="association-account-link-button" />
              </Typography>
            </Grid>
          </Grid>
        </label>
      )}
    </List>
  )
}

export { AccountConnectionsList }
